import { c as _c } from "react/compiler-runtime";
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { Chip } from '../../../../../../components/chip/chip';
import { ScrollableContainer } from '../../../../../../components/scrollable-container/scrollable-container';
import { type useCarouselSourceFilter } from '../../hooks/use-carousel-source-filter';
import styles from './source-filter-controls.module.scss';
export const SourceFilterControls = t0 => {
  const $ = _c(5);
  const {
    filterState
  } = t0;
  const {
    setCurrentSourceIdFilter,
    sourceFilterItems
  } = filterState;
  let t1;
  if ($[0] !== setCurrentSourceIdFilter || $[1] !== sourceFilterItems) {
    t1 = sourceFilterItems && sourceFilterItems.length > 2 && <ScrollableContainer><ul className={styles.filter}>{sourceFilterItems.map(sourceFilterItem => <li key={sourceFilterItem.value}><Chip aria-current={sourceFilterItem.selected} className={styles.filter__item} label={sourceFilterItem.label ?? ""} onClick={() => setCurrentSourceIdFilter(sourceFilterItem.value)} theme={sourceFilterItem.selected ? ChipTheme.Active : ChipTheme.Light} /></li>)}</ul></ScrollableContainer>;
    $[0] = setCurrentSourceIdFilter;
    $[1] = sourceFilterItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};